import script from "./WhatAvaitsList.vue?vue&type=script&setup=true&lang=js"
export * from "./WhatAvaitsList.vue?vue&type=script&setup=true&lang=js"

import "./WhatAvaitsList.vue?vue&type=style&index=0&id=0800b032&lang=scss"

const __exports__ = script;

export default __exports__